import { useRecoilState } from 'recoil';
import {
    authState,
    addressesState,
    distributionTypeState,
} from 'store/state';
import { useTranslation } from 'react-i18next';
import Dropdown from 'components/UI/Dropdown';
import {
    STANDARD_ALLOCATION_TYPE,
    CUSTOM_ALLOCATION_TYPE,
} from '_constants/allocationTypes';
import {
    useAddressesActions,
} from 'services';
import { webLibSdk } from 'helpers';
import classNames from 'classnames';
import CopyButton from 'components/UI/CopyButton';
import Connection from './Connection';
import InfoTable from './InfoTable';
import StandardAllocationType from './AllocationsTable/StandardAllocationType';
import CustomAllocationType from './AllocationsTable/CustomAllocationType';
import StyledPrivateSale from './styles';

const Allocations = () => {
    const [distributionType, setDistributionType] = useRecoilState(distributionTypeState);
    const [auth] = useRecoilState(authState);
    const [addresses] = useRecoilState(addressesState);
    const currentAddress = addresses.current || null;

    const { t } = useTranslation();
    const { getAddresses } = useAddressesActions();
    const [standardAddress, customAddress] = webLibSdk.getAllocationDistributionAddresses();

    const updateAllocationType = (type) => {
        if (distributionType === type) return;

        window.localStorage.setItem('distributionType', type);
        setDistributionType(type);
        webLibSdk.updateAllocationType(type);
        getAddresses();
    };

    const Trigger = () => (
        <div className="btn-outline distributionAllocationTypes">
            {distributionType === STANDARD_ALLOCATION_TYPE && `Standard - ${standardAddress}`}
            {distributionType === CUSTOM_ALLOCATION_TYPE && `Custom - ${customAddress}`}
            <CopyButton
                noText
                text={distributionType === STANDARD_ALLOCATION_TYPE ? standardAddress : customAddress}
            />
        </div>
    );

    return (
        <StyledPrivateSale className="container">
            <Dropdown
                Trigger={Trigger}
                className="allocation-type-dropdown"
            >
                <li
                    className={classNames({ active: distributionType === STANDARD_ALLOCATION_TYPE })}
                    onClick={() => updateAllocationType(STANDARD_ALLOCATION_TYPE)}
                >
                    {`Standard - ${standardAddress}`}
                </li>
                <li
                    className={classNames({ active: distributionType === CUSTOM_ALLOCATION_TYPE })}
                    onClick={() => updateAllocationType(CUSTOM_ALLOCATION_TYPE)}
                >
                    {`Custom - ${customAddress}`}
                </li>
            </Dropdown>

            <InfoTable distributionAllocationType={distributionType} />

            { auth && currentAddress && (
                distributionType === STANDARD_ALLOCATION_TYPE
                    ? <StandardAllocationType currentAddress={currentAddress} />
                    : <CustomAllocationType currentAddress={currentAddress} />
            )}
            {!auth && <Connection t={t} />}
        </StyledPrivateSale>
    );
};

export default Allocations;
